export default {
  retrieveDriverList (state, payload) {
    state.driverList = [].concat(payload.driverList)
  },
  getDriverInfo (state, payload) {
    state.driverInfo = payload.driverInfo
    if (state.driverInfo.bus_info === null) {
      state.driverInfo.bus_id = ""
    } else {
      state.driverInfo.bus_id = state.driverInfo.bus_info.id
    }
  },
  deleteDriver (state, payload) {
    state.driverList.splice(payload.driverInfo.index, 1);
  },
  updateState (state, payload) {
    state.currentFilter = payload.filter ? Object.assign({}, payload.filter) : null
    state.currentSort = payload.sort ? Object.assign({}, payload.sort) : null
    state.currentPage = payload.page ? payload.page : null
  }
}
